import {Component, OnInit} from '@angular/core';
import {ModelloDispositivoApiDescriptor, ScortaMaterialeApiDescriptor, ScortaScuolaMaterialeApiDescriptor} from "../../../models/magazzino.model";
import {ConfirmationService, MessageService, SelectItem} from "primeng/api";
import {DialogService} from "primeng/dynamicdialog";
import {MagazzinoService} from "../../../services/magazzino.service";
import {ImpreseService} from "../../../services/imprese.service";
import {ActivatedRoute} from "@angular/router";
import {dateAsDDMMYYYY, datetimeAsHHMMSS, downloadXlsxWorkbook, exportDataToXlsx, getMagazzinoUserSummary, MagazzinoUserSummary} from "../../../lib/support";
import {Impresa} from "../../../models/impresa.model";

@Component({
  selector: 'app-stato-scorte-scuole',
  templateUrl: './stato-scorte-scuole.component.html',
  styleUrls: ['./stato-scorte-scuole.component.scss'],
	providers: [DialogService, ConfirmationService],

})
export class StatoScorteScuoleComponent implements OnInit
{

	uiReady: boolean;
	dataReady: boolean;

	optionsModelli: SelectItem<ModelloDispositivoApiDescriptor>[];
	filterModello: ModelloDispositivoApiDescriptor;

	optionsScuole: SelectItem<{cui: string, rif_pratica: number}>[];
	filterScuole: {cui: string, rif_pratica: number};

	modelliById: {[key: string]: ModelloDispositivoApiDescriptor};
	scuoleById: {[key: string]: {cui: string, rif_pratica: number}};

	listingMateriali: ModelloDispositivoApiDescriptor[];
	listingScorte: ScortaScuolaMaterialeApiDescriptor[];
	filteredScorte: ScortaScuolaMaterialeApiDescriptor[];

	userSummary: MagazzinoUserSummary;
	lockAzienda: Impresa;
	aziendaLockParam: number;

	constructor(
		private confirmationService: ConfirmationService,
		private messageService: MessageService,
		public dialogService: DialogService,
		private backendMagazzino: MagazzinoService,
		private impreseService: ImpreseService,
		private route: ActivatedRoute
	) {
		this.loadData();
	}

	ngOnInit(): void {
        this.uiReady = true;
    }

	loadData () {
		this.userSummary = getMagazzinoUserSummary();

		const canSeeAll = this.userSummary.isSmartFiber || this.userSummary.isPresidio || this.userSummary.isAdmin;
		this.aziendaLockParam = canSeeAll ? (this.route.snapshot.params["aziendaid"] ?? null) : this.userSummary.idImpresa;

		let materialiById = {};
		const loaded = {
			materiali:			false,
			scorte_scuole:		false,
		};

		const checkUpdateState = () => {
			if (Object.values(loaded).every((value) => value)) {
				const nmus = this.listingScorte.map((item) => item.nmu);
				this.optionsModelli = [{
					label: "TUTTI",
					value: null
				}, ...this.listingMateriali.filter((item) => {
					return nmus.indexOf(item.nmu) != -1;
				}).map((item) => {
					return {
						label: `${item.nmu}: ${item.descrizione}`,
						value: item
					}
				})];

				this.updateFiltered();
				this.dataReady = true;

			}

		};

		this.backendMagazzino.modelloDispositivoList().subscribe((result) => {
			this.listingMateriali = result.listing;
			this.modelliById = {};
			for (let item of result.listing) {
				this.modelliById[`${item.id}`] = item;
			}
			loaded.materiali = true;
			checkUpdateState();
		});

		this.backendMagazzino.scorteScuoleList(null, this.aziendaLockParam).subscribe((result) => {
			// console.log("scorte CORRENTI: ", result);
			this.listingScorte = result.listing.filter((item) => {
				return item.balance != 0;
			});
			this.scuoleById = {};
			for (let item of this.listingScorte) {
				this.scuoleById[item.cui] = {cui: item.cui, rif_pratica: item.rif_pratica}
			}
			this.optionsScuole = [{
				label: "TUTTE",
				value: null
			}, ...Object.values(this.scuoleById).map((item) => {
				return {
					label: item.cui,
					value: item
				}
			})];
			loaded.scorte_scuole = true;
			checkUpdateState();
		});

	}

	updateFiltered () {
		this.filteredScorte = this.listingScorte.filter((item) => {
			return (this.filterScuole == null || item.cui == this.filterScuole.cui) &&
				(this.filterModello == null || this.filterModello.nmu == item.nmu)
		});
	}

	downloadDataAsXlsx () {
		const sheet_name = "scorte_scuole";
		const wb = exportDataToXlsx(
			["scuola", "nmu", "qt"],
			this.filteredScorte.map((item) => {
				return {
					nmu: item.nmu,
					scuola: item.cui,
					qt: item.balance
				}
			}),{},
			sheet_name
		);

		const now = new Date();
		downloadXlsxWorkbook(wb, `${sheet_name}_${dateAsDDMMYYYY(now, "")}_${datetimeAsHHMMSS(now)}.xlsx`);

	}
}
